exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vmodal {\n  padding-top: 32px;\n}\n.vmodal .ant-modal-content {\n  max-width: 1080px;\n  margin: 0 auto;\n}\n", ""]);

// exports
